/**
 * Represents the current status of the telephony call state machine.
 * Transitions follow:
 * IDLE → REGISTERING → REGISTERED → TRYING → RINGING → ACTIVE → HELD → HANGING_UP → TERMINATED → IDLE
 * Additional states: FAILED, RECONNECTING
 */
export enum CallStatus {
  Idle = 0,
  Registering = 1,
  Registered = 2,
  Trying = 3,
  Ringing = 4,
  Active = 5,
  Held = 6,
  HangingUp = 7,
  Terminated = 8,
  Failed = 9,
  Reconnecting = 10,
}
